import 'hammerjs';
import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { Capacitor } from '@capacitor/core';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

// The native app is served from bundled files, so the service worker adds no
// offline value. It also rewrites every failed request as a synthetic 504,
// which hides the real network error, and it survives app reinstalls, so any
// worker registered by an earlier build has to be torn down explicitly.
async function removeServiceWorker() {
  if (!Capacitor.isNativePlatform() || !('serviceWorker' in navigator)) {
    return;
  }
  try {
    const registrations = await navigator.serviceWorker.getRegistrations();
    await Promise.all(registrations.map((registration) => registration.unregister()));
    if (typeof caches !== 'undefined') {
      const keys = await caches.keys();
      await Promise.all(keys.map((key) => caches.delete(key)));
    }
  } catch (error) {
    console.error('[sw] teardown failed', error);
  }
}

// Prevent zooming smaller than initial 100% on iOS
if (typeof window !== 'undefined') {
  window.addEventListener('gesturechange', (e: any) => {
    if (e.scale < 1.0) {
      e.preventDefault();
    }
  }, { passive: false });
}

document.addEventListener('DOMContentLoaded', () => {
  removeServiceWorker().finally(() => {
    platformBrowserDynamic().bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()], })
    .catch(err => console.error(err));
  });
});
